export default "__VITE_ASSET__BIQ_6cGm__"